import { render } from "./ManufacturerAddForm.vue?vue&type=template&id=09c336f8"
import script from "./ManufacturerAddForm.vue?vue&type=script&lang=js"
export * from "./ManufacturerAddForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__